module.exports = __webpack_public_path__ + "img/clock.e7cb63d9.svg";